import * as React from "react";

const SvgUnpin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <mask
      id="unpin_svg__a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#unpin_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.603 9.464 1.007 3.951 2.29 2.417 23.734 20.34l-1.283 1.535-6.915-5.78v1.855l-1.415 1.414-3.535-3.536-4.243 4.243H4.93v-1.414l4.243-4.243-3.536-3.535L7.05 9.464zm5.917 4.946v1.524L9.065 11.48h.95zm5.551-5.653-2.772 2.772 1.54 1.288 2.646-2.645.707.707 1.415-1.415-7.071-7.07-1.415 1.414.707.707-3.151 3.15 1.54 1.289 3.026-3.025z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgUnpin;
